import { useState } from "react";

const useControlOptions = () => {
    const [isColorOptionsVisible, setColorOptionsVisible] = useState(false);
    const [isDotsOptionsVisible, setDotsOptionsVisible] = useState(false);
    const [colorMode, setColorMode] = useState("simple"); // "simple" or "gradient"
    const [gradientType, setGradientType] = useState("linear"); // "linear" or "radial"

    const toggleColorOptions = () => {
        setColorOptionsVisible(!isColorOptionsVisible);
    };

    const toggleDotsOptions = () => {
        setDotsOptionsVisible(!isDotsOptionsVisible);
    };

    const handleColorModeChange = (mode) => {
        setColorMode(mode);
    };

    const handleGradientTypeChange = (type) => {
        setGradientType(type);
    };

    return {
        isColorOptionsVisible,
        toggleColorOptions,
        isDotsOptionsVisible,
        toggleDotsOptions,
        colorMode,
        handleColorModeChange,
        gradientType,
        handleGradientTypeChange
    };
};

export default useControlOptions;